import React, { PropTypes } from 'react';
import { Link } from 'react-router-dom';
// import StarRatingComponent from 'react-star-rating-component';
import { connect } from 'react-redux';
// import { history } from 'react-router';
import { bindActionCreators } from 'redux';
import * as documentUploadActions from '../../actions/documentUploadActions';
import * as constant from '../../constants/constant';
import Pagination from "react-js-pagination";
import Moment from 'react-moment';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import AppointmentDocs from '../sitemanagement/appointmentDocs';
import $ from "jquery";
import './../../styles/css/newDocument.css'
import * as dashboardActions from "../../actions/dashboardActions";
import { Form, Button, Col, Container, Row, Tabs, Tab } from "react-bootstrap";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import userTime from './../../images/userTime.png'
import arrow from './../../images/arrow.png'
import completed from './../../images/completed.png'
import pending from './../../images/pending.png'
import SaaSContract from './uploadDocumentPages/SaaSContract'
import ProofOfEducation from './uploadDocumentPages/ProofOfEducation'
import ProofOfPracticingClinic from './uploadDocumentPages/ProofOfPracticingClinic'
import IdentificationProof from './uploadDocumentPages/IdentificationProof'
import ProfilePicture from './uploadDocumentPages/ProfilePicture'
import SpecialityCertificate from './uploadDocumentPages/SpecialityCertificate'
import EmploymentHistory from './uploadDocumentPages/EmploymentHistory'
import IndemnityInsurance from './uploadDocumentPages/IndemnityInsurance'
import MedicalLicense from './uploadDocumentPages/MedicalLicense'
import * as specialistActions from "../../actions/specialistActions";
import { sort } from 'semver';



let btnSize = { fontSize: '13' };
class SpecialistDocuments extends React.Component {
	constructor(props, context) {
		super(props, context);
		this.state = {
			isLoader: true,
			specialistDocument: [],
			token: '',
			flag: 1,
			activePage: 1,
			count: 10,
			sortColumnName: '',
			sortOrder: -1,
			logoutButton: false,
			openDocumentModal: false,
			docModal: false,
			docAndStatus: [],


			//newStates
			mainDisplay: true,
			SaaS:false,
			POE: false,
			POPC: false,
			PP: false,
			SC: false,
			II: false,
			IP:false,
			EH: false,
			ML: false,


			mlData: null,
			poeData: null,
			popcData: null,
			poiData: null,
			ehData: null,
			iiData: null, 
			scData: null,
			ppData:null,


		}


		// this.goToUploadDocumentPage = this.goToUploadDocumentPage.bind(this);
		// this.handlePageChange = this.handlePageChange.bind(this);
		// this._sortClass = this._sortClass.bind(this);
		// this.sortChanged = this.sortChanged.bind(this);
		// this.deleteSpecialistDocument = this.deleteSpecialistDocument.bind(this);
		// this.goToEditDocumnetPage = this.goToEditDocumnetPage.bind(this);
		this.onLogoutclick = this.onLogoutclick.bind(this);
		// this.openModal = this.openModal.bind(this);
		// this.hideDocumentModal = this.hideDocumentModal.bind(this)
		// this.hidedocModal = this.hidedocModal.bind(this)
		this.toggle = this.toggle.bind(this)

		this._logout = this._logout.bind(this)
		this.handleClick = this.handleClick.bind(this);
		this.handleOutsideClick = this.handleOutsideClick.bind(this);
		this.goBack = this.goBack.bind(this)

	}

	_logout(event) {
		let userId = localStorage.getItem('userId')
		this.props.logoutAction.logout({ 'userId': userId })
		event.preventDefault();
		localStorage.clear();
		this.props.history.push('/');
	}
	toggle() {
		var windowWidth = $(window).width();
		if(windowWidth < 768){
			$("body").toggleClass("sidebar-open");
		}else{
			$("body").toggleClass("sidebar-collapse");
		}	}


	componentWillMount() {
		let objectDocument = {
			userId: localStorage.getItem('userId'),
			userType: 'specialist'
		}
		this.props.actions.getAllDocumentTypes(objectDocument)
		this.props.actions.getSpecialistDocument(objectDocument);
		this.props.actions.getSpecialistDocumentAndStatus();
		let obj = {
            userId: localStorage.getItem("userId"),
          };
        this.props.specialistActions.getSpecialistProfileData(obj);
	}



	
	componentWillReceiveProps(nextProps) {
		console.log(nextProps)
		if (nextProps.success) {

		
			if(this.state.specialistDocument  && nextProps.specialistDocument && nextProps.specialistDocument.data && ( this.state.specialistDocument.length !== nextProps.specialistDocument.data.length)){
				let objectDocument = {
				userId: localStorage.getItem('userId'),
				userType: 'specialist'
			}
			this.props.actions.getAllDocumentTypes(objectDocument)
			}

			this.setState({
				specialistDocument: nextProps.specialistDocument && nextProps.specialistDocument.data? nextProps.specialistDocument.data : [] ,
				totalCount: nextProps.totalCount,
				isLoader: false,
				docTypes: nextProps.docTypes && nextProps.docTypes.docs? nextProps.docTypes.docs: [],
				docStatuses: nextProps.docTypes? nextProps.docTypes.specialistInfo: {},
				imageCopy: nextProps.specialistInfo && nextProps.specialistInfo.tempProfileImage
				? nextProps.specialistInfo.tempProfileImage
				: "",
			}, ()=>{
				console.log(this.state.specialistDocument)
			})
		} else {
			this.setState({
				isLoader: false
			})
		}

	}


	onLogoutclick(data) {
		if (this.state.logoutButton == false) {
			this.setState({
				logoutButton: true
			});
		}
		else {
			this.setState({
				logoutButton: false
			});
		}
	}


	handleOutsideClick(e) {
		// ignore clicks on the component itself
		if (this.node && this.node.contains(e.target)) {
			return;
		}

		this.handleClick();
	}


	handleClick() {
		if (!this.state.logoutButton) {
			// attach/remove event handler
			document.addEventListener('click', this.handleOutsideClick, false);
		} else {
			document.removeEventListener('click', this.handleOutsideClick, false);
		}

		this.setState(prevState => ({
			logoutButton: !prevState.logoutButton,
		}));
	}

	// submitForVerification = () => {
	// 	let userId = localStorage.getItem('userId');
	// 	this.props.actions.submitForVerification({userId});
	// }





	goBack(){
		this.setState({
			mainDisplay: true,
			SaaS:false,
			POE: false,
			POPC: false,
			PP: false,
			SC: false,
			II: false,
			IP:false,
			EH:false,
			ML: false,
		})
		
	}




	render() {
    var user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
		var specialistDocument = this.state.specialistDocument
		var defaultImagePath = constant.PRODUCTION_IMAGE_URL + 'uploads/common/noUserImage.jpg';
		var user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
		var documentpath = constant.PRODUCTION_IMAGE_URL + 'uploads/' + user._id + '/';
		var defaultImagePath;


    if (user.gender == 'Male') {
		defaultImagePath =  constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER  + constant.COMMON_FOLDER + 'doctor_m.png'
	}


	else{
		defaultImagePath =  constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER  + constant.COMMON_FOLDER + 'doctor_f.png'
	}

		if (user.image == constant.DEFAULT_USER_IMAGE) {
			if (user.gender == 'Male') {
				imagePath =  constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER  + constant.COMMON_FOLDER + 'doctor_m.png'
			}
			else{
			imagePath =  constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER  + constant.COMMON_FOLDER + 'doctor_f.png'
			}
				// var imagePath = constant.PRODUCTION_IMAGE_URL + constant.COMMON_FOLDER + user.image;
		} 
		
		
		else {
			var imagePath = constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + localStorage.getItem('userId') + '/' + user.image;
		}



		

		var user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
		var condition = (((user.userName != undefined || user.gender != undefined )&& user.availabilityCount > 0 )&& user.isVerified == '2')
		var userType = localStorage.getItem('userType');

		const {
			isVettingTriggered,
			isProfileSaved 
		} = this.props;


		var mlData = null;
		var poeData = null;
		var scData = null;
		var poiData = null;
		var ehData = null;
		var popcData = null;
		var iiData = null;
		var ppData = null;


		var rows = this.state.docTypes
		var active = [], pend= [], comp = [];
		
		var sorted = []
		if(rows && rows.length){
			for(var i =0; i< rows.length; i++){
				
				if(rows[i].name=="Medical License" && sorted.length == 0 ){
					if(this.state.mlData == null){
	
						this.setState({
							mlData : rows[i]
						})
					}
					sorted.push(rows[i])
				}
				
				if(rows[i].name=="Profile Photo" && sorted.length == 1){
					if(this.state.ppData == null){
						this.setState({
							ppData : rows[i]
						})
					}
				
					
					sorted.push(rows[i])
				}
				if(rows[i].name=="Proof of Education" && sorted.length ==2 ){
					if(this.state.poeData == null){
	
						this.setState({
							poeData : rows[i]
						})
					}
					sorted.push(rows[i])
				}
	
				if(rows[i].name=="Speciality Certificates" && sorted.length == 3){
					if(this.state.scData == null){
						this.setState({
							scData : rows[i]
						})
					}
					sorted.push(rows[i])
				}
				if(rows[i].name == "Proof of Identification" && sorted.length == 4){
					if(this.state.poiData == null){
						this.setState({
							poiData : rows[i]
						})
					}
					sorted.push(rows[i])
				}
	
				if(rows[i].name=="Employment History" && sorted.length == 5){
	
					if(this.state.ehData == null){
						this.setState({
							ehData : rows[i]
						})
					}
	
					sorted.push(rows[i])
				}
				
				if(rows[i].name=="Proof of Practicing Clinic" && sorted.length == 6){
					if(this.state.popcData == null){
						this.setState({
							popcData: rows[i]
						})
					}
	
					sorted.push(rows[i])
				}
				if(rows[i].name=="Indemnity Insurance" && sorted.length == 7 ){
	
					if(this.state.iiData == null){
						this.setState({
							iiData:rows[i]
						})
					}
					sorted.push(rows[i])
				}
				if((i == (rows.length-1)) && (sorted.length !==rows.length)){
					i = -1
				}
				else if(sorted.length == rows.length){
					i= rows.length
				}
			}

			var expiryDates = {}

			if(this.state.specialistDocument && this.state.specialistDocument.length > 0){
				for(let i = 0; i < this.state.specialistDocument.length;i++){
					if(this.state.specialistDocument[i].documentTypeName == "Medical License" ){
						expiryDates.medicalLicence = this.state.specialistDocument[i].expiryDate
					}

					if(this.state.specialistDocument[i].documentTypeName == "Indemnity Insurance"){
						expiryDates.indemnityInsurance = this.state.specialistDocument[i].expiryDate
					}
					
				}
			}

	
		

		if(this.state.docStatuses){
			
			for(let i = 0; i< sorted.length; i++){
				if(sorted[i].name == "Medical License" && this.state.docStatuses && this.state.docStatuses.medicalLicence){
					if(this.state.docStatuses.medicalLicence == 4 || this.state.docStatuses.medicalLicence == 2){
						console.log('hi')
						active.push(sorted[i])
					}
					else if(this.state.docStatuses.medicalLicence == 1 ){
						
						comp.push(sorted[i])
					}
					else{
						pend.push(sorted[i])
					}
				}

				if(sorted[i].name == "Profile Photo"  && this.state.docStatuses && this.state.docStatuses.profilePhoto){
					
					if(this.state.docStatuses.profilePhoto == 4 || this.state.docStatuses.profilePhoto == 2 || !this.state.docStatuses.profilePhoto){
						// && this.state.imageCopy == "noUserImage.jpg"
						active.push(sorted[i])
					}
					else if(this.state.docStatuses.profilePhoto == 1){
						comp.push(sorted[i])
					}
					else{
						console.log('pending photo')
						pend.push(sorted[i])
					}
				}

				if(sorted[i].name == "Proof of Education"  && this.state.docStatuses && this.state.docStatuses.eduProofStatus){
					if(this.state.docStatuses.eduProofStatus == 4 || this.state.docStatuses.eduProofStatus == 2){
						active.push(sorted[i])
					}
					else if(this.state.docStatuses.eduProofStatus == 1 ){
						comp.push(sorted[i])
					}
					else{
						pend.push(sorted[i])
					}
				}

				if(sorted[i].name == "Speciality Certificates" && this.state.docStatuses && this.state.docStatuses.specialityCert){
					if(this.state.docStatuses.specialityCert == 4 || this.state.docStatuses.specialityCert == 2){
						active.push(sorted[i])
					}
					else if(this.state.docStatuses.specialityCert == 1 ){
						comp.push(sorted[i])
					}
					else{
						pend.push(sorted[i])
					}
				}

				if(sorted[i].name == "Proof of Identification" && this.state.docStatuses && this.state.docStatuses.idProofStatus){
					if(this.state.docStatuses.idProofStatus == 4 || this.state.docStatuses.idProofStatus == 2){
						active.push(sorted[i])
					}
					else if(this.state.docStatuses.idProofStatus == 1 ){
						comp.push(sorted[i])
					}
					else{
						pend.push(sorted[i])
					}
				}

				
				if(sorted[i].name == "Employment History" && this.state.docStatuses && this.state.docStatuses.empHistory){
					if(this.state.docStatuses.empHistory == 4 || this.state.docStatuses.empHistory ==2){
						active.push(sorted[i])
					}
					else if(this.state.docStatuses.empHistory ==1 ){
						comp.push(sorted[i])
					}
					else{
						pend.push(sorted[i])
					}
				}


				if(sorted[i].name == "Proof of Practicing Clinic" && this.state.docStatuses && this.state.docStatuses.practiceClinicProof){
					
					if(this.state.docStatuses.practiceClinicProof == 4 || this.state.docStatuses.practiceClinicProof == 2){
						active.push(sorted[i])
					}
					else if(this.state.docStatuses.practiceClinicProof == 1 ){
						comp.push(sorted[i])
					}
					else{
						pend.push(sorted[i])
					}
				}



				if(sorted[i].name == "Indemnity Insurance" && this.state.docStatuses && this.state.docStatuses.indemnityInsurance){
					if(this.state.docStatuses.indemnityInsurance == 4 || this.state.docStatuses.indemnityInsurance == 2){
						active.push(sorted[i])
					}
					else if(this.state.docStatuses.indemnityInsurance == 1 ){
						comp.push(sorted[i])
					}
					else{
						pend.push(sorted[i])
					}
				}



			}

		}
	}
		// sorted.forEach(doc=>{
		// 	if(doc.status == 'Active' ){
		// 		active.push(doc)
		// 	}
		// 	else if(doc.status == "Pending"){
		// 		pend.push(doc)
		// 	}
		// 	else {
		// 		comp.push(doc)
		// 	}
		// })




		


		return (
			<div>
				<header className="main-header">
				<Link to={condition ? "/specialist/my-appointment":null} className="logo">						
				<span className="logo-mini">{userType==='specialist'?<img src={require('../../images/img/logo_er_ms_specialist.png')} alt=''/>:<img src={require('../../images/img/logo_er_ms.png')} alt="" />}</span>
		        <span className="logo-lg">{userType==='specialist'?<img src={require('../../images/img/logo_er.png')} alt="" />:<img src={require('../../images/img/logo_er_old.png')} alt=''/>}</span> </Link>
					<nav className="navbar navbar-static-top" role="navigation">
						<Link to="#" href="#" className="sidebar-toggle" data-toggle="push-menu" role="button" onClick={this.toggle}> <img src={require('../../images/img/menu_list.svg')} alt="" /> <span className="sr-only">Toggle navigation</span> </Link>
						<div className='align-right'>
						<Link  style={{cursor: 'pointer'}}  to={{
							pathname:'/specialist-requirements',
						}}>

							<button
							className="btn btn-round btn-w-90"
							// onClick={this.goToUploadDocumentPage}
							>
							<span style={{ display: "flex", alignItems: 'center', justifyContent: 'center' }}>
							</span>
								<span className="btn-text">Help</span>
						</button>
						</Link>
						</div>	
							<div className="navbar-custom-menu">
							<ul className="nav navbar-nav">
								<li ref={node => { this.node = node; }} onClick={this.handleClick} className={this.state.logoutButton == true ? "dropdown user user-menu show" : "dropdown user user-menu"}>
									<Link href="#" className="dropdown-toggle" data-toggle="dropdown">
										<img src={imagePath} className="user-image" alt="User Image" onError={(e) => { e.target.src = defaultImagePath }} />
										<span className="hidden-xs name-capitalize">{user.firstName ? user.firstName : ''} {user.lastName ? user.lastName : ''}</span> </Link>
									<ul className={this.state.logoutButton === true ? "dropdown-menu popupdropdown show" : "dropdown-menu popupdropdown"}>

										<li className="user-setting">	<Link to={{ pathname: "/specialist/my-settings", state: 1 }}>

											<img
												src={require('../../images/Slicing/Settings-profile.png')}
												className="user-image"
												alt="User Image"
												onError={e => {
													e.target.src = defaultImagePath;
												}}
											/>
											<span>Settings</span>
										</Link></li>
										<li
											className="user-footer passwordLink"
										// style={{ textAlign: "center" }}
										>

											<Link

												className="uploadLink"
												onClick={this._logout}
											>
												<img
													src={require('../../images/Slicing/logout-profile.png')}
													className="user-image"
													alt="User Image"
													onError={e => {
														e.target.src = defaultImagePath;
													}}
												/>
												<span>	Sign out</span>
											</Link>
										</li>
									</ul>
								</li>
							</ul>
						</div>
					</nav>
				</header>
				<div className="content-wrapper">

					<section className="content container-fluid">
                    <ToastContainer position="bottom-left" rtl={true} />
						<div className="row">
							<div className="col-md-12" style={{padding: '0px'}}>
								<div className="boxMrgB proCalendar">
									<div className="nav-tabs-custom ipad-my-document">
							

								
                                    
                                        <Card className="newDoc-root" style={{margin:'15px'}}>


											{this.state.mainDisplay &&
                                    <CardContent style={{display:'flex',justifyContent:'center',alignItems:'center',flexDirection:'column',padding: '30px 0px'}}>
                                     
                                        <div className="doc-cards" >

                                        <Row>
                                        <Col lg={1} id="accountDelayedIcon">
                                                <img src={userTime} height="50" />
                                            </Col>

                                            <Col lg={11} style={{display: 'flex',flexDirection:'column'}}> 
                                                <h4 style={{fontFamily:'sansation_regular',marginRight:'auto'}}>Account Activation is Delayed</h4>
                                                <p style={{color: '#bfbfbf',fontWeight:600,fontSize:'14px',marginBottom:'0px',cursor:'pointer'}}>We're currently working with our vetting agency for verification of your documents. Please allow up to 14 business days for full completion of the verification process.</p>
                                                </Col> 
                                        </Row>

                                        <hr color="lavender" width="90%"/>
                                        <div className="req-steps" >
                                        <Typography style={{fontWeight:'bold'}}>Required Steps</Typography>            
                                        <p style={{marginLeft:"50px",fontFamily:'roboto',fontSize:'14px'}}>Thank you for signing up with Medfix. Please upload the following required documents for verification purposes. Please allow up to 14 business days for full completion of the verification process.</p>  
                                        </div>

											   <div className="doc-card" onClick={()=>this.setState({SaaS:true, mainDisplay:false})}>

												<h3>Legal Agreements</h3>

												<img src={arrow} height="25" />
												</div>  
												{active.map((doc,index)=>


													    <div className="doc-card" key={index}
														
														onClick={()=>{
															
															{
															doc.name=="Proof of Education"?
																this.setState({POE:true, mainDisplay:false})
															:
															doc.name=="Proof of Identification"?
																this.setState({IP:true, mainDisplay:false})
															:
															doc.name=="Speciality Certificates"?
															this.setState({SC:true, mainDisplay:false})
															:
															doc.name=="Medical License"?
															this.setState({ML:true, mainDisplay:false})
															:
															doc.name=="Indemnity Insurance"?
															this.setState({II:true, mainDisplay:false})
															:
															doc.name=="Proof of Practicing Clinic"?
															this.setState({POPC:true, mainDisplay:false})
															:
															doc.name=="Profile Photo"?
															this.setState({PP:true, mainDisplay:false})
															:
															doc.name=="Speciality Certificates"?
															this.setState({SC:true, mainDisplay:false})
															:
															doc.name=="Employment History"?
															this.setState({EH:true, mainDisplay:false})
															:""
														}
															}}
														
														>

														<h3>{doc.name}</h3>
		   
														<img src={arrow} height="25"/>
													</div>  
												)}
									


                                      


                                         <div className="pend-steps" >

                                        	<Typography style={{fontWeight:'bold'}}>Pending Steps</Typography>            
                                        
                                        </div>




										{pend.map((doc,index)=>


										<div className="doc-card" key={index}
										style={{cursor: 'context-menu !important'}}
										>

										<h3>{doc.name}</h3>

										<img src={pending} height="25"/>
										</div>  
										)}



                                               



                                   

                                         <div className="comp-steps" >
                                        <Typography style={{fontWeight:'bold'}}>Completed Steps</Typography>            
                                        
                                        </div>
                                               

                                   
										{comp.map((doc,index)=>


											<div className="doc-card" key={index}>

										<h3>{doc.name}{" "}<br/> {doc.name=="Medical License" && <p style={{marginBottom: 0,fontSize: 14}}>Expires on:{" "}<Moment format="YYYY/MM/DD">
											{expiryDates.medicalLicence}
										</Moment></p> }
										{doc.name=="Indemnity Insurance" &&<p style={{marginBottom: 0,fontSize: 14}}>Expires on:{" "} <Moment format="YYYY/MM/DD">
										 {expiryDates.indemnityInsurance}
											</Moment> </p>}
										
										</h3>

											<img src={completed} height="25"/>
											</div>  
											)}



                                        </div>






                                    </CardContent>}


												
									{this.state.SaaS &&
									<SaaSContract 
									goBack={this.goBack}
									/>
									}

										
									{this.state.POE &&
									<ProofOfEducation
									poeData = {this.state.poeData}
									goBack = {this.goBack}
									/>
									}

									{this.state.POPC &&
									<ProofOfPracticingClinic
									popcData = {this.state.popcData}
									goBack={this.goBack}
									/>
									}

									{this.state.IP &&
									<IdentificationProof
									poiData = {this.state.poiData}
									goBack={this.goBack}
									/>
									}
									
									{this.state.SC &&
									<SpecialityCertificate
									scData = {this.state.scData}
									goBack={this.goBack}
									/>
									}
										

									{this.state.II &&
									<IndemnityInsurance
									iiData = {this.state.iiData}
									goBack={this.goBack}
									/>
									}


									{this.state.EH &&
									<EmploymentHistory
									ehData =  {this.state.ehData}
									goBack={this.goBack}
									/>
									}
									
									{this.state.PP &&
									<ProfilePicture
									ppData = {this.state.ppData}
									goBack={this.goBack}
									/>
									}
									
									{this.state.ML &&
									<MedicalLicense
									mlData= {this.state.mlData}
									goBack={this.goBack}
									/>
									}

                                  </Card>








									</div>
								</div>
							</div>
						</div>
					</section>













					{this.state.docModal ? <AppointmentDocs openModal={this.state.docModal} hideConditionModal={this.hidedocModal} doctorId={this.state.doctorId} patientId={this.state.patientId} /> : ''}
					<div className="Copyrightafterlogin">
					<p>Medfix &copy; 2018. All rights reserved</p>

					</div>
				</div>
			</div>
		);
	}
}

//this tells what state should expose on props
function mapStateToProps(state, ownProps) {
	return {
		specialistDocument: state.uploadDocument.specialistDocument ? state.uploadDocument.specialistDocument : [],
		totalCount: state.uploadDocument.specialistDocument ? state.uploadDocument.specialistDocument.totalCount : 0,
		success: state.uploadDocument.specialistDocument ? state.uploadDocument.specialistDocument.success : false,
		isProfileSaved: state.uploadDocument.specialistDocument ? state.uploadDocument.specialistDocument.isProfileSaved : false,
		isVettingTriggered: state.uploadDocument.specialistDocument ? state.uploadDocument.specialistDocument.isVettingTriggered : false,
		documentTypes: state.uploadDocument.userTypeData,
		uploadedSpecialistData: state.uploadDocument.uploadedSpecialistData,
		specialistDocumentData: state.uploadDocument.specialistDocumentData,
		docAndStatus: state.uploadDocument.docAndStatus,
		docTypes: state.uploadDocument.docTypes,
		specialistInfo: state.specialist.specialistProfile,
	};
}
//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(documentUploadActions, dispatch),
		logoutAction: bindActionCreators(dashboardActions, dispatch),
		specialistActions: bindActionCreators(specialistActions, dispatch),
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(SpecialistDocuments);
